<script setup>
import { ref } from 'vue';
import Spinner from "@/components/frontend/ui/Spinner.vue";
import PlacesAutocomplete from "@/components/atoms/map/PlacesAutocomplete.vue";

const isLocating = ref(false);
const coords = ref(null);
const error = ref(null);

const emit = defineEmits(['localized']);

const OnClicklocalizeMe = () => {
  error.value = null;
  if (navigator.geolocation) {
    isLocating.value = true;
    navigator.geolocation.getCurrentPosition((position) => {
      coords.value = position.coords;
      isLocating.value = false;
      emit('localized', coords.value);
    }, (geolocationError) => {
      error.value = geolocationError.message;
      isLocating.value = false;
    });
  } else {
    error.value = 'Geolocation is not supported by this browser.';
  }
}

const onPlaceChanged = (place) => {
  coords.value = {
    latitude: place.geometry.location.lat(),
    longitude: place.geometry.location.lng(),
  };
  emit('localized', coords.value);
}

</script>
<template>
  <div>
    <div class="input-group input-group-lg mb-2 mr-sm-2">
      <PlacesAutocomplete
        @placeChanged="onPlaceChanged"
        :disabled="isLocating"
        :placeholder="$t('Search for a location')"
        class="form-control" />
      <div class="input-group-append">
        <button class="btn btn-outline-primary d-flex  align-items-center"
                @click="OnClicklocalizeMe"
                :disabled="isLocating"
        >
          <span v-if="isLocating" class="mr-3">
            <Spinner style="width: 20px"></Spinner>
          </span>
          <span v-else class="mr-3">
            <i class="fa fa-location-arrow" aria-hidden="true"></i>
          </span>
          {{ $t('Current position') }}
        </button>
      </div>
    </div>
    <div v-if="error" class="invalid-feedback d-block">
      {{ error }}
    </div>
  </div>
</template>